import { Injectable } from '@angular/core';

import { environment } from 'env/environment';

@Injectable({
  providedIn: 'root'
})
export class UrlService {
  private static readonly STORAGE_COREAPIURL_KEY: string = 'CoreApiUrl';

  public setServerApiUrl(url: string): void {
    if (url) {
      url = url.replace(/\/+$/, '');
      localStorage.setItem(UrlService.STORAGE_COREAPIURL_KEY, url);
    }
  }

  public buildServerApiUrl(...parts: string[]): string {
    const baseUrl: string =
      localStorage.getItem(UrlService.STORAGE_COREAPIURL_KEY) ??
      environment.coreApiUrl;

    return [baseUrl]
      .concat(parts)
      .join('/');
  }

  public buildGameServerApiUrl(...parts: string[]): string {
    const baseUrl = environment.overrideGameApiUrl ?? this.buildServerApiUrl('api/nova');

    return [baseUrl]
      .concat(parts)
      .join('/');
  }

  public buildIdentityServerApiUrl(...parts: string[]): string {
    return this.buildServerApiUrl('Login', ...parts);
  }
}
